import React from 'react';

import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useCfmz } from "./_csMdlCfm";
import { useMsgz } from "./_csMdlMsg";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _cv_61___Mz from "./_cv_61___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from './icm';

import * as icvI1z___TzAby from './icvI1z___TzAby';
import * as icvI10___Tz from './icvI10___Tz';
import * as icvI10___Mz from './icvI10___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

//let $i10rs = [] as _ht.ls;
//let $i10r_fsts = [] as _ht.ls;

let $i1zz = icvI1z___Mz.ilzI1zz();

//let $bkdz = {} as _ht.dz;

export const N = (pz: {
  sPz: _ht.dz,
  pagez: _ht.dz,
}) => {

  const _frcUdt = ls.frcUdt();
  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();
  const _sCfmz = useCfmz();


  React.useEffect(() => {
    cmFTH.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        new Promise( _exit => {
          $i1zz = icvI1z___Mz.crtI1zz();
          _exit(null);
        })
      ],
      udtAsync: () => [
        icvI1z___Mz.loadI1zrDzAsync({
          i1zr_fst: pz.sPz.crt.i1zr_fst,
        })
        .then((_dz: _ht.dz) => {
          //hf.l(`Iccv23b2 71: ${hf.s(_dz)}`);
          $i1zz = _dz;
        })
      ]
    })
  }, [
    pz.sPz.crt._fst,
  ])

  //hf.l(`Iccv23b2 75: ${hf.s($i1zz)}`)
  //hf.l(`icvI1zS11Co1 92: ${hf.s(_gStgz.crt)}`)
  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

/*
        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a('mb/2'),
        }),
*/

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
//              abtType: 'cttCmnz',
              abtType: 'ornCmnz',
              boxStlz: a('mb/1'),
              cz: {
                ls: [
                  {
                    msgCz: {
                      textz: {
                        pfx: '部屋・日時を選択ください。'
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(BoxC.N, {
              key: -20,
//              boxStlz: a('dw/f f/1 mb/2 mt/1 p/1 sc/lm1'),
              boxStlz: a('dw/f f/1 mb/0.5 mt/0.5 p/0.5 sc/lm1'),
              oClds: [

                cr.c(icvI1z___TzAby.V3, { // 現在の状況
                  key: -10,
                  sPz: pz.sPz,
                  frcUdt: _frcUdt,
                  cz: {
                    bEdit: 
                      _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ? 
                        true 
                      : false,
                    i10r_fsts: pz.pagez.i10r_fsts,
                    date: 
                      pz.sPz.crt.ctt == 'r' ?
                        _hmDTM.getTdy()
                      : pz.sPz.crt.ctt == 'e' ?
                        _gStgz.crt.alyMthSttDate
                      : _hmDTM.getTdy(),
                    i1zz: $i1zz,
                    _31r_fst: _gUserz.crt._31rz._fst,
                  },
                }),

              ]
            }),

            cr.c(icvI10___Tz.T, {
              key: -30,
              sPz: pz.sPz,
              frcUdt: _frcUdt,
              cz: {
                _31r_fst: _gUserz.crt._31rz._fst,
                i1zz: $i1zz,
                bEdit: 
                  _hm.i(pz.sPz.crt.phs, ['crt', 'udt']) ? 
                    true 
                  : false,
/*
                onChgAsync: () => {
                  $bkdz = icm.grtBkd({
                    i1zs: [$i1zz],
                  });
                  _frcUdt();
                }
*/
              }
            }),

            cr.c(GridC.N, {
              key: -40,
              abtType: 'barBtnViewCmnz',
              boxStlz: a(`pt/0.5`),
              lineCs: [
                {
                  cellCs: [
                    {
                      boxStlz: a(`pb/0.5`),
                      oClds: [

                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'backCmnz',
                          lblCz: {
                            textz: {
                              pfx: `${pz.sPz.crt.dffz.tgt}一覧画面に戻る`,
                            },
                          },
                          pslPtyz: {
                            onPress: () => {
                              pz.sPz.set({
                                steps: [0],
//                                bBack: true,
                              });
                            }
                          },
                        }),
                      ]
                    },
                    {
                      boxStlz: a(`pb/0.5`),
                      oClds: [

                        cr.c(BtnC.N, {
                          key: -10,
                          abtType: 'nextCmnz',
                          lblCz: {
                            textz: {
                              pfx: 
                                pz.sPz.crt.ctt == 'r' ?
                                  '上記の部屋・日時を押さえて次へ'
                                : pz.sPz.crt.ctt == 'e' ?
                                  '次へ'
                                : '',
                            },
                          },
                          pslPtyz: {
                            onPress: async () => {
                              //hf.l('icvI1zS11Co 232: here')
                              icm.saveI1zzAddAsync1({
                                role: 's',
                                ctt: pz.sPz.crt.ctt,
                                _31r_fst: _gUserz.crt._31rz._fst,
                                i1zz: $i1zz,
                                i10rs: pz.pagez.i10rs,
                                i17rs: pz.pagez.i17rs,
                                i15rs: pz.pagez.i15rs,
                                i18rz: {},
                                hdys: pz.pagez.hdys,
                                chkStep: 1,
                                sMsgz: _sMsgz,
                                sLdrz: _sLdrz,
                                sCfmz: _sCfmz,
                                atrAsync: (_dz: _ht.dz) => {
                                  //hf.l('icvI1zS11Co 243: here')
                                  pz.sPz.set({
                                    steps: [2],
                                    phs: 'crt',
                                    i1zr_fst: _dz.i1zrz._fst,
                                  });
                                }
                              })

                            }
                          },
                        }),


                      ]
                    }
                  ]
                }
              ],
            })

          ]
        })

      ]
    })
  );
};
